import React from 'react';
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import logo from "@/assets/auchan-logo-footer.jpg";

function Footer() {
    const [showModal, setShowModal] = React.useState(false);
    const markdown = `# **Introducere**
Bine ați venit la Auchan! Confidențialitatea dvs. este de o importanță majoră pentru noi. Această politică de confidențialitate explică modul în care colectăm, utilizăm, partajăm și protejăm informațiile dvs. personale atunci când utilizați website-ul nostru, [www.franciza.auchan.ro](www.franciza.auchan.ro).

## **Datele Operatorului**
Auchan Romania S.A, cu sediul social în București, strada Brașov nr. 25, etaj 4, camera 1, Sector 6, înregistrată la Registrul Comerțului București sub nr. J40/2731/2005, având codul unic de înregistrare 17233051.

## **1. Informații pe care le colectăm**

### **1.1 Informații furnizate de dvs.**
Când utilizați website-ul nostru, putem colecta informații personale pe care ni le furnizați voluntar, inclusiv, dar fără a se limita la:
- Nume și prenume
- Nume companie, administrator
- Adresa de email
- Număr de telefon
- Adresa poștală
- Informații de plată (dacă efectuați achiziții prin intermediul website-ului nostru)

### **1.2 Informații colectate automat**
Putem colecta automat anumite informații despre vizita dvs. pe website-ul nostru, inclusiv:
- Adresa IP
- Tipul și versiunea browser-ului
- Pagini vizualizate și timp petrecut pe pagină
- Sistemul de operare
- URL-ul de referință
- Comenzile dumneavoastră și produsele vizualizate
- Valoarea achizițiilor făcute

## **2. Utilizarea informațiilor**
Informațiile colectate sunt utilizate pentru următoarele scopuri:
- Procesarea și gestionarea comenzilor și plăților
- Îmbunătățirea experienței utilizatorului pe website-ul nostru
- Comunicarea cu dvs. cu privire la comenzi, oferte speciale, și alte informații legate de serviciile noastre
- Personalizarea conținutului și reclamelor
- Analizarea și înțelegerea comportamentului utilizatorilor pentru a îmbunătăți website-ul și serviciile noastre

## **3. Partajarea informațiilor**
Nu vindem și nu închiriem informațiile dvs. personale către terți. Putem partaja informațiile dvs. personale cu terți doar în următoarele situații:
- Cu furnizorii de servicii care ne ajută să operăm website-ul și să furnizăm serviciile noastre, cum ar fi procesatorii de plăți și serviciile de livrare.
- Dacă este necesar pentru a respecta legile și reglementările aplicabile sau pentru a răspunde la o solicitare din partea autorităților publice.
- Pentru a proteja drepturile, proprietatea sau siguranța Auchan România S.A, a utilizatorilor noștri sau a altora.

## **4. Securitatea datelor**
Luăm măsuri tehnice și organizatorice adecvate pentru a proteja informațiile dvs. personale împotriva accesului neautorizat, pierderii, distrugerii sau alterării.

## **5. Drepturile dvs. conform GDPR**
În conformitate cu Regulamentul General privind Protecția Datelor (GDPR), aveți următoarele drepturi:
- **Dreptul de acces**: Puteți solicita o copie a datelor personale pe care le deținem despre dvs.
- **Dreptul la rectificare**: Puteți solicita corectarea datelor personale inexacte sau incomplete.
- **Dreptul la ștergere**: Puteți solicita ștergerea datelor personale atunci când nu mai sunt necesare sau când prelucrarea acestora este ilegală.
- **Dreptul la restricționarea prelucrării**: Puteți solicita restricționarea prelucrării datelor dvs. personale în anumite circumstanțe.
- **Dreptul la portabilitatea datelor**: Puteți solicita transferul datelor dvs. personale către o altă organizație într-un format structurat, utilizat în mod curent și care poate fi citit automat.
- **Dreptul de a vă opune**: Puteți să vă opuneți prelucrării datelor dvs. personale în scopuri de marketing direct sau din motive legate de situația dvs. particulară.

Pentru a vă exercita aceste drepturi, vă rugăm să ne contactați la [contact@auchan.ro](mailto:contact@auchan.ro) sau [dpo@auchan.ro](mailto:dpo@auchan.ro).

## **6. Modificări ale politicii de confidențialitate**
Ne rezervăm dreptul de a modifica această politică de confidențialitate în orice moment. Orice modificare va fi publicată pe această pagină și va intra în vigoare imediat după publicare. Vă încurajăm să verificați periodic această pagină pentru a fi la curent cu cele mai recente informații despre practicile noastre de confidențialitate.

## **7. Contact**
Dacă aveți întrebări sau nelămuriri cu privire la această politică de confidențialitate sau la practicile noastre de prelucrare a datelor, vă rugăm să ne contactați la:
- ✉ București, strada Brașov nr. 25, etaj 4, camera 1, Sector 6
- 🕿 021-9141
- 📧 [contact@auchan.ro](mailto:contact@auchan.ro)
- 📧 [dpo@auchan.ro](mailto:dpo@auchan.ro)

Vă mulțumim că utilizați serviciile Auchan România și că aveți încredere în noi pentru protejarea confidențialității dvs.
`

    return (
        <>
            <footer className="bg-white">
                <div className="mx-auto max-w-screen-xl px-4 pb-6 pt-16 sm:px-6 lg:px-8 lg:pt-24">
                    <span className="flex items-center">
                        <span className="h-px flex-1 bg-gray-300"></span>
                        <img src={logo} className="text-center h-16 w-16" alt="logo" />
                        <span className="h-px flex-1 bg-gray-300"></span>
                        <br />
                    </span>
                    <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 px-4">
                        <div>

                            <ul className="mt-8 flex justify-center gap-6 sm:justify-start md:gap-8">
                                <li>
                                    <a
                                        href="https://www.facebook.com/AuchanRO"
                                        rel="noreferrer"
                                        target="_blank"
                                        className="text-red-600 transition hover:text-red-600/75"
                                    >
                                        <span className="sr-only">Facebook</span>
                                        <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                            <path
                                                fillRule="evenodd"
                                                d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href="https://www.instagram.com/auchanromania/"
                                        rel="noreferrer"
                                        target="_blank"
                                        className="text-red-600 transition hover:text-red-600/75"
                                    >
                                        <span className="sr-only">Instagram</span>
                                        <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                            <path
                                                fillRule="evenodd"
                                                d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href="https://twitter.com/auchanromania"
                                        rel="noreferrer"
                                        target="_blank"
                                        className="text-red-600 transition hover:text-red-600/75"
                                    >
                                        <span className="sr-only">Twitter</span>
                                        <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                            <path
                                                d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"
                                            />
                                        </svg>
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href="https://www.youtube.com/channel/UCwd_ItoBh8R3FvEuLwKOYxA"
                                        rel="noreferrer"
                                        target="_blank"
                                        className="text-red-600 transition hover:text-red-600/75"
                                    >
                                        <span className="sr-only">Youtube</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="currentColor" viewBox="0 0 45 45" aria-hidden="true">
                                            <path d="M43.2,33.9c-0.4,2.1-2.1,3.7-4.2,4c-3.3,0.5-8.8,1.1-15,1.1c-6.1,0-11.6-0.6-15-1.1c-2.1-0.3-3.8-1.9-4.2-4C4.4,31.6,4,28.2,4,24c0-4.2,0.4-7.6,0.8-9.9c0.4-2.1,2.1-3.7,4.2-4C12.3,9.6,17.8,9,24,9c6.2,0,11.6,0.6,15,1.1c2.1,0.3,3.8,1.9,4.2,4c0.4,2.3,0.9,5.7,0.9,9.9C44,28.2,43.6,31.6,43.2,33.9z"></path><path fill="#FFF" d="M20 31L20 17 32 24z"></path>
                                        </svg>
                                    </a>
                                </li>

                                <li>
                                    <a
                                        href="https://www.auchan.ro/"
                                        rel="noreferrer"
                                        target="_blank"
                                        className="text-red-600 transition hover:text-red-600/75"
                                    >
                                        <span className="sr-only">Website</span>
                                        <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                                            <path
                                                fillRule="evenodd"
                                                d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10c5.51 0 10-4.48 10-10S17.51 2 12 2zm6.605 4.61a8.502 8.502 0 011.93 5.314c-.281-.054-3.101-.629-5.943-.271-.065-.141-.12-.293-.184-.445a25.416 25.416 0 00-.564-1.236c3.145-1.28 4.577-3.124 4.761-3.362zM12 3.475c2.17 0 4.154.813 5.662 2.148-.152.216-1.443 1.941-4.48 3.08-1.399-2.57-2.95-4.675-3.189-5A8.687 8.687 0 0112 3.475zm-3.633.803a53.896 53.896 0 013.167 4.935c-3.992 1.063-7.517 1.04-7.896 1.04a8.581 8.581 0 014.729-5.975zM3.453 12.01v-.26c.37.01 4.512.065 8.775-1.215.25.477.477.965.694 1.453-.109.033-.228.065-.336.098-4.404 1.42-6.747 5.303-6.942 5.629a8.522 8.522 0 01-2.19-5.705zM12 20.547a8.482 8.482 0 01-5.239-1.8c.152-.315 1.888-3.656 6.703-5.337.022-.01.033-.01.054-.022a35.318 35.318 0 011.823 6.475 8.4 8.4 0 01-3.341.684zm4.761-1.465c-.086-.52-.542-3.015-1.659-6.084 2.679-.423 5.022.271 5.314.369a8.468 8.468 0 01-3.655 5.715z"
                                                clipRule="evenodd"
                                            />
                                        </svg>
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="flex flex-rox justify-end space-x-8 text-center">

                            <div className="text-center sm:text-left">
                                {/* <a className="text-gray-700 transition hover:text-gray-700/75" href="https://www.auchan.ro/protectia-datelor-personale-si-politica-de-confidentialitate"> Protectia datelor personale </a> */}

                                <ul className="mt-8 space-y-4 text-sm">
                                    <li>
                                        <div className="text-gray-700 transition hover:text-gray-700/75"
                                             onClick={() => setShowModal(true)}> Protectia datelor personale
                                        </div>
                                    </li>

                                    {/* <li>
                                        <a className="text-gray-700 transition hover:text-gray-700/75" href="https://www.auchan.ro/protectia-datelor-personale-si-politica-de-confidentialitate"> Protectia datelor personale </a>
                                    </li>

                                    <li>
                                        <a className="text-gray-700 transition hover:text-gray-700/75" href="#"> Legal </a>
                                    </li> */}

                                    {/* <li>
                                        <a
                                            className="group flex justify-center gap-1.5 ltr:sm:justify-start rtl:sm:justify-end"
                                            href="#"
                                        >
                                            <span className="text-gray-700 transition group-hover:text-gray-700/75">
                                                Live Chat
                                            </span>

                                            <span className="relative flex h-2 w-2">
                                                <span
                                                    className="absolute inline-flex h-full w-full animate-ping rounded-full bg-teal-400 opacity-75"
                                                ></span>
                                                <span className="relative inline-flex size-2 rounded-full bg-teal-500"></span>
                                            </span>
                                        </a>
                                    </li> */}
                                </ul>
                            </div>

                            <div className="text-center sm:text-left">
                                {/* <a className="text-gray-700 transition hover:text-gray-700/75" href="https://www.auchan.ro/rechemare-produse"> Rechemare produse </a> */}

                                <ul className="mt-8 space-y-4 text-sm">
                                    {/* <li>
                                        <a className="text-gray-700 transition hover:text-gray-700/75" href="https://www.auchan.ro/magazine"> Retea magazine </a>
                                    </li> */}

                                    <li>
                                        <a className="text-gray-700 transition hover:text-gray-700/75"
                                           href="https://www.auchan.ro/rechemare-produse"> Rechemare produse </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="mt-12 border-t border-gray-100 pt-6 mb-12">
                        <div className="text-center sm:flex sm:justify-between sm:text-left">
                            {/*<p className="text-sm text-gray-500">*/}
                            {/*    <span className="block sm:inline">All rights reserved</span>*/}
                            
                            {/*    <span>&nbsp;&middot;&nbsp;</span>*/}
                            
                            {/*    <div*/}
                            {/*        className="inline-block text-teal-600 underline transition hover:text-teal-600/75"*/}
                            {/*    //href="https://www.auchan.ro/protectia-datelor-personale-si-politica-de-confidentialitate"*/}
                            {/*    >*/}
                            {/*        Privacy Policy*/}
                            {/*    </div>*/}
                            {/*</p>*/}

                            <div className="flex flex-col">
                                {/*<p className="mt-4 text-sm text-gray-500 sm:order-first sm:mt-0">&copy; Copyright Auchan 2023. Toate drepturile rezervate!</p>*/}
                                {/* <p className="mt-4 text-sm text-gray-500 sm:order-first sm:mt-0">Versiunea din 2 Iulie</p> */}
                            </div>
                        </div>
                    </div>

                    {showModal ? (
                        <>
                            <div
                                className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
                            >
                                <div className="relative w-auto my-6 mx-auto max-w-7xl max-h-full text-left list-none">
                                    {/*content*/}
                                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                                        {/*header*/}
                                        <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                                            <h3 className="text-3xl font-semibold">
                                                Politica de Confidențialitate
                                            </h3>
                                            <button
                                                className="p-1 ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                                                onClick={() => setShowModal(false)}
                                            >
                                                <span className="bg-transparent text-black opacity-5 h-6 w-6 text-2xl block outline-none focus:outline-none">
                                                    ×
                                                </span>
                                            </button>
                                        </div>
                                        {/*body*/}
                                        <div className="relative p-6 flex-auto prose prose-lg">
                                            <div className="my-4 text-blueGray-500 text-lg leading-relaxed">
                                                <Markdown remarkPlugins={[remarkGfm]}>{markdown}</Markdown>
                                            </div>
                                        </div>
                                        {/*footer*/}
                                        <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                                            <button
                                                className="bg-emerald-500 text-white active:bg-emerald-600 font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150"
                                                type="button"
                                                onClick={() => setShowModal(false)}
                                            >
                                                Inchide
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                        </>
                    ) : null}
                </div>
            </footer>
        </>
    );
}

export default Footer;